import Tippy from "@tippyjs/react";
import React from "react";
import { ISellingPoint } from "../../../../interfaces/ISellingPoint";

interface ISellingPointProps {
    sellingPoint: ISellingPoint;
}

const SellingPoint: React.FC<ISellingPointProps> = (props) => {
    const { sellingPoint } = props;

    const containsHTMLRegex = /<[^>]*>/gim;
    const toolTipRegex = /<[^>]*data-tippy-content="([^"]*)"[^>]*>([^<]*)<\/[^>]*>/gim;

    if (containsHTMLRegex.test(sellingPoint.text)) {
        const toolTip = toolTipRegex.exec(sellingPoint.text);

        if (toolTip) {
            const data = {
                text: toolTip[2],
                toolTip: toolTip[1],
                raw: toolTip[0]
            };

            return (
                <Tippy
                    content={data.toolTip}
                    key={sellingPoint.id}
                    placement="bottom"
                    arrow
                    trigger="mouseenter click">
                    <p>{data.text}</p>
                </Tippy>
            );
        }
    }

    return (
        <p
            dangerouslySetInnerHTML={{
                __html: sellingPoint.text
            }}
        />
    );
};

export default SellingPoint;
